/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import UploadZip from "../uploadDocument/UploadFileZip";
import { Modal } from "react-bootstrap";
import TableComponent from "../../components/tableComponent/TableComponent";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import moment from "moment";
import { toast } from "react-toastify";
import qs from "qs";
import axiosMain from "../../http/axios/axios_main";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import {
  fetchAuctionRequest,
  fetchMarkRequest,
  getAllCategoriesAction,
  getAllTeaTypes,
  userWiseAuctionCenterDetails,
  getSaleNoRequest,
  bindAuctioneerRequest,
  getExportDataSeller,
  getAllTaxInvoiceActionSuccess,
  getExportDataSellerApiCall,
  getGstExcelByIdAction,
  disableGSTExcel,
  disableIrnUploadDocumentButton,
} from "../../store/actions";
import CustomToast from "../../components/Toast";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  downloadAllDocument,
  bindAuctionDate,
  getAllTaxInvoiceSaleAction,
  getlotnobyuserid,
  getlotnofortao,
  getinvoicenofortao,
  getlotnoforteaboard,
  getinvoicenobyuserid,
  getinvoicenoforteaboard,
  previewpdf,
  bindsalenobyseason,
  get_searchinvoicelist,
  getusersbyauctioncenter,
  getExportData,
  getExportDataApiCall,
  getAllAuctionCenterAscAction,
} from "../../store/actions";
import Base64ToExcelDownload from "../Base64ToExcelDownload";
import { uploadedFileDownload } from "../uploadDocument/UploadedFileDownload";
import { NO_OF_RECORDS } from "../../constants/commonConstants";
import axios from "axios";
import { useAuctionDetail } from "../../components/common/AunctioneerDeteailProvider";
import { CLIENT_NAME, SERIAL_NUMBER } from "../../constants/commonConstants";

const data = [
  {
    state: "California",
    stateCode: "CA",
    stateInitial: "C",
    action: "Some action",
  },
  {
    state: "New York",
    stateCode: "NY",
    stateInitial: "NY",
    action: "Another action",
  },
];

function InvoiceList({ open, setOpen, modalRight }) {
  const [pageNo, setpageNo] = useState(1);
  const currentDate = new Date();
  const [Base64Data, setBase64Data] = useState([]);
  const [viewcertificateDetail, setviewcertificateDetail] = useState({});
  const [showOwnerModalHistory, setShowCirtificateModal] = useState(false);
  const [Base64savedigitalsign, setBase64savedigitalsign] = useState([]);
  const currentYear = new Date().getFullYear();
  const [loader, setLoader] = useState(false);
  const [allAuctionDate, setallAuctionDate] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [allLoatNo, setallLoatNo] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const seasonYear = moment().year();
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const roleCode = atob(sessionStorage.getItem("argument6"));
  const handleCloseHistory = () => setShowmodal(false);
  const [showmodal, setShowmodal] = useState(false);
  const [downclick, setdownclick] = useState(false);
  const [allAuctioneerList, setallAuctioneerList] = useState([]);
  const [invoiceNo, setInvoiceNo] = useState([]);
  const [season, setSeason] = useState(seasonYear);
  const [Loading, setloading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [DealBookSearch, setDealBookSearch] = useState({
    season: season + "",
    roleCode: roleCode,
    saleNo: null,
    teaType: null,
    auctionDate: null,
    status: null,
    lotNo: null,
    invoiceNumber: null,
    bilingType: null,
    einvoiceEligibility: null,
    auctionCentre: null,
    auctioneer: null,
    userId: parseInt(atob(sessionStorage.getItem("argument2"))),
    url: "/postauction/invoiceList/searchInvoiceList",
    exportType: "",
    isExport: 0,
  });
  const [exportType, setexportType] = useState("");
  const [ViewDealBookTaoData, setViewDealBookTaoData] = useState([]);
  const [allTeaTypeList, setallTeaTypeList] = useState([]);
  const [allSaleNoList, setallSaleNoList] = useState([]);
  const [isGstExcelDisabled, setIsGstExcelDisabled] = useState(false);

  const { auctionDetailId, auctionCenterUserId, auctionCenterId, userId } =
    useAuctionDetail();
  const auctioneerData = useSelector(
    (state) => state?.invoiceListReducer?.auctioneerData?.responseData
  );
  const excelById = useSelector(
      (state) => state?.BuyerTaxInvoice?.excelById?.responseData)
  const isApiCalled = useSelector(
    (state) => state?.BuyerTaxInvoice?.isApiCalled
  );
  const years = [];
  for (let i = 0; i <= 6; i++) {
    const year = currentYear - i;
    years.push(year);
  }

  console.log(excelById, "excelById");

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (excelById != null) {
  //       for (const name of excelById) {
  //         const signData = {
  //           action: "1",
  //           serialnumber: SERIAL_NUMBER,
  //           src: name?.base64,
  //           reason: "-",
  //           field: "1-363,718,533,788",
  //           place: "-",
  //           certificateName: CLIENT_NAME,
  //         };
  //         console.log("Location", signData);
  //         try {
  //           const response = await axios.post(
  //             "https://localhost:29739/teaboard/allDocSignerallDocSigner",
  //             signData
  //           );

  //           if (response.data && response.data.signerResponse) {
  //             let data1 = [
  //               {
  //                 base64: response.data.signerResponse.pdfsigndata,
  //                 filename: name.filename,
  //                 invoiceNo: name.invoiceNo,
  //                 invoicenolist: selectedserialNumber,
  //                 userId: userId,
  //               },
  //             ];

  //             const response1 = await axiosMain.post(
  //               "/postauction/sellertaxinvoice/saveDigitalSign",
  //               data1
  //             );

  //             if (response1.data.statusCode === 200) {
  //                 CustomToast.success(response1.data.message);
  //             } else {
  //               CustomToast.error(response1.data.message);
  //             }
  //           }
  //         } catch (error) {
  //           console.error("Error:", error);
  //           // Handle error here
  //         }
  //       }
  //     }
  //   };
  //   fetchData();
  // }, [excelById]);

  const isIRNUploadDocumentDisabled = useSelector(
    (state) => state?.BuyerTaxInvoice?.isIRNUploadDocumentDisabled
  );

  useEffect(() => {
    if (isApiCalled) {
      setRows([])
      dispatch(
        get_searchinvoicelist({
          ...DealBookSearch,
          pageNo: 1,
          noOfRecords: NO_OF_RECORDS,
          userId: parseInt(atob(sessionStorage.getItem("argument2"))),
          invoicenos: selectedInvoices
        })
      );
}}, [isApiCalled]);

  // By Vimal :- This code is written to prevent multiple toasts from appearing based on the length of excelById
  useEffect(() => {
    const fetchData = async () => {
      if (excelById != null) {
        for (let i = 0; i < excelById.length; i++) {
          const name = excelById[i];

          const signData = {
            action: "1",
            serialnumber: SERIAL_NUMBER,
            src: name?.base64,
            reason: "-",
            field: "1-363,718,533,788",
            place: "-",
            certificateName: CLIENT_NAME,
          };

          console.log("Location", signData);
          try {
            const response = await axios.post(
              "https://localhost:29739/teaboard/allDocSignerallDocSigner",
              signData
            );

            if (response.data && response.data.signerResponse) {
              let data1 = [
                {
                  base64: response.data.signerResponse.pdfsigndata,
                  filename: name.filename,
                  invoiceNo: name.invoiceNo,
                  invoicenolist: selectedserialNumber,
                  userId: userId,
                },
              ];

              const response1 = await axiosMain.post(
                "/postauction/sellertaxinvoice/saveDigitalSign",
                data1
              );

              if (response1.data.statusCode === 200) {
                if (i === excelById.length - 1) {
                  CustomToast.success(response1.data.message);
                }
              } else {
                CustomToast.error(response1.data.message);
              }
            }
          } catch (error) {
            console.error("Error:", error);
          }
        }
      }
    };

    fetchData();
  }, [excelById]);

  const fetchInvoiceNumbers = async () => {
    let apiURL = "";
    const userId = parseInt(atob(sessionStorage.getItem("argument2")));
    const auctionCenterId = atob(window.location.pathname.split("/")[4]);

    // Conditionally setting the API URL
    if (
      atob(sessionStorage.getItem("argument6")) === "BUYER" ||
      atob(sessionStorage.getItem("argument6")) === "AUCTIONEER" ||
      atob(sessionStorage.getItem("argument6")) === "SELLER"
    ) {
      // apiURL = `postauction/invoiceList/getInvoiceNoByUserId/${userId}`;
      apiURL = `postauction/invoiceList/getInvoiceNoByUserIdNew`;
    } else if (
      atob(sessionStorage.getItem("argument6")) === "TEABOARDUSER" ||
      atob(sessionStorage.getItem("argument6")) === "TAOUSER"
    ) {
      apiURL = `postauction/invoiceList/getInvoiceNoForTeaBoardNew`;
    }

    try {
      const response = await axiosMain.post(apiURL, {
        userid: parseInt(
          atob(sessionStorage.getItem("argument6")) === "TEABOARDUSER" ||
          atob(sessionStorage.getItem("argument6")) === "TAOUSER"
        )
          ? undefined
          : userId,
        season: DealBookSearch.season,
        saleNo: JSON.parse(DealBookSearch.saleNo),
        auctionCenterId: JSON.parse(DealBookSearch.auctionCentre),
      });
      if (response.data) {
        setInvoiceNo(response.data.responseData);
      }
    } catch (error) {
      console.error("Failed to fetch invoice numbers:", error);
    }
  };

  const featchLotNumber = () => {
    if (
      atob(sessionStorage.getItem("argument6")) == "BUYER" ||
      atob(sessionStorage.getItem("argument6")) == "AUCTIONEER" ||
      atob(sessionStorage.getItem("argument6")) == "SELLER"
    ) {
      dispatch(
        getlotnobyuserid({
          userId: parseInt(atob(sessionStorage.getItem("argument2"))),
          season: DealBookSearch.season,
          saleNo: parseInt(DealBookSearch.saleNo),
          auctionCenterId: parseInt(DealBookSearch.auctionCentre),
        })
      );
    } else if (
      atob(sessionStorage.getItem("argument6")) == "TAOUSER" ||
      atob(sessionStorage.getItem("argument6")) == "TEABOARDUSER"
    ) {
      let lotnojson = {
        // userId: parseInt(atob(sessionStorage.getItem("argument2"))),
        season: DealBookSearch.season,
        saleNo: parseInt(DealBookSearch.saleNo),
        auctionCenterId: parseInt(DealBookSearch.auctionCentre),
      };
      dispatch(getlotnoforteaboard(lotnojson));
    } else {
      dispatch(
        getlotnoforteaboard({
          season: DealBookSearch.season,
          saleNo: parseInt(DealBookSearch.saleNo),
          auctionCenterId: parseInt(DealBookSearch.auctionCentre),
        })
      );
    }
  };

  const ViewDealBookList = async () => {
    DealBookSearch.url = "";
    DealBookSearch.exportType = "";
    DealBookSearch.isExport = null;
    if (
      DealBookSearch.auctionCentre == null ||
      DealBookSearch.auctionCentre == "" ||
      DealBookSearch.auctionCentre == undefined
    ) {
      CustomToast.error("Please select Auction Center");
      return false;
    } else if (
      DealBookSearch.saleNo == null ||
      DealBookSearch.saleNo == "" ||
      DealBookSearch.saleNo == undefined
    ) {
      CustomToast.error("Please select sale No.");
      return false;
    } else {
      if (DealBookSearch.auctionDate == "") {
        DealBookSearch.auctionDate = null;
      }
      if (DealBookSearch.auctionCentre == "") {
        DealBookSearch.auctionCentre = null;
      }
      if (DealBookSearch.teaType == "") {
        DealBookSearch.teaType = null;
      }
      if (DealBookSearch.status == "") {
        DealBookSearch.status = null;
      }
      if (DealBookSearch.lotNo == "") {
        DealBookSearch.lotNo = null;
      }
      if (DealBookSearch.invoiceNo == "") {
        DealBookSearch.invoiceNo = null;
      }
      if (DealBookSearch.bilingType == "") {
        DealBookSearch.bilingType = null;
      }
      if (DealBookSearch.einvoiceEligibility == "") {
        DealBookSearch.einvoiceEligibility = null;
      }
      if (DealBookSearch.auctioneer == "") {
        DealBookSearch.auctioneer = null;
      }

      console.log("DealBookSearch 261", DealBookSearch);
      dispatch(
        get_searchinvoicelist({
          ...DealBookSearch,
          pageNo: 1,
          noOfRecords: NO_OF_RECORDS,
          userId: parseInt(atob(sessionStorage.getItem("argument2"))),
          invoicenos: selectedInvoices
        })
      );
      setpageNo(2);
      setRows([]);
    }
  };
  const searchResults = useSelector(
    (state) => state?.invoiceListReducer?.searchinvoicelist?.responseData
  );

  const searchResultsAll = useSelector(
    (state) => state?.invoiceListReducer?.ApiStatusInvoice
  );

  const isGstExcelDisabledButton = useSelector((state) => state?.invoiceListReducer?.isGstExcelDisabled)
  console.log("isGstExcelDisabledButton", isGstExcelDisabledButton)
  useEffect(() => {
    setIsGstExcelDisabled(isGstExcelDisabledButton);
  }, [isGstExcelDisabledButton]);

  useEffect(() => {
    if (true == searchResultsAll || searchResults == null) {
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }
  });

  const searchResultss = useSelector(
    (state) => state?.invoiceListReducer?.searchinvoicelist?.responseData
  );
  const auctineerList = useSelector(
    (state) => state.saleNoReducer.auctineerList
  );
  useEffect(() => {
    if (
      searchResultss != undefined &&
      searchResultss != null &&
      searchResultss != ""
    ) {
      setViewDealBookTaoData(searchResultss);
      if (searchResultss && searchResultss.length > 0) {
        setRows((prevRows) => [...prevRows, ...searchResultss]);
        if (searchResultss.length < 20) {
          setIsDisabled(true);
        }
        else {
          setIsDisabled(false);
        }
      }
    } else {
      setViewDealBookTaoData([]);
      // setRows([]);
      setRows(prevRows => (prevRows.length > 0 ? prevRows : []));
      setIsDisabled(true);
    }
  }, [searchResultss]);
  // useEffect(() => {
  //   if (searchResultss && searchResultss.length > 0) {
  //     setRows((prevRows) => [...prevRows, ...searchResultss]);
  //   }
  // }, [searchResultss]);
  useEffect(() => {
    dispatch(getAllTeaTypes());
    dispatch(bindAuctioneerRequest({ roleCode: "AUCTIONEER" }));
    dispatch(fetchMarkRequest());
    dispatch(fetchAuctionRequest());
    dispatch(getAllCategoriesAction());
  }, []);

  const allTeaType = useSelector(
    (state) => state?.teaTypeManage?.allTeaTypes?.responseData
  );

  const auctionCenterDropDownData = useSelector(
    (state) => state?.auctionCenter?.userWiseAuctionCenterDetails?.responseData
  );
  const bindAuctionDatelist = useSelector(
    (state) => state?.BuyerTaxInvoice?.getAllTaxInvoiceSale?.responseData
  );
  const loatNoList = useSelector((state) => state.saleNoReducer.loatNoList);
  useEffect(() => {
    setallAuctionDate(bindAuctionDatelist);
  }, [bindAuctionDatelist]);
  const listSaleNo = useSelector(
    (state) => state?.invoiceListReducer?.bindsalenobyseason?.responseData
  );
  useEffect(() => {
    setallSaleNoList(listSaleNo);
  }, [listSaleNo]);



  useEffect(() => {
    setallAuctioneerList(auctineerList);
  }, [auctineerList]);
  const listofLots = useSelector(
    (state) => state?.invoiceListReducer?.getlotnobyuserid?.responseData
  );

  useEffect(() => {
    if (listofLots != undefined && listofLots != null && listofLots != "") {
      setallLoatNo(listofLots);
    } else {
      setallLoatNo([]);
    }
  }, [listofLots]);

  //Export
  const handleExport = (exportTypee) => {
    DealBookSearch.userId = parseInt(atob(sessionStorage.getItem("argument2")));
    setIsAllSelected(false);
    if (
      DealBookSearch.auctionCentre == null ||
      DealBookSearch.auctionCentre == "" ||
      DealBookSearch.auctionCentre == undefined
    ) {
      CustomToast.error("Please select Auction Center");
      return false;
    } else if (
      DealBookSearch.saleNo == null ||
      DealBookSearch.saleNo == "" ||
      DealBookSearch.saleNo == undefined
    ) {
      CustomToast.error("Please select sale No.");
      return false;
    } else {
      setexportType(exportTypee);
      DealBookSearch.url = "/postauction/invoiceList/searchInvoiceList";
      DealBookSearch.exportType = exportTypee;
      DealBookSearch.isExport = 1;
      dispatch(
        getExportData({
          ...DealBookSearch,
          pageNo: pageNo,
          noOfRecords: NO_OF_RECORDS,
        })
      );
    }
  };

  const getExportDataResponse = useSelector(
    (state) => state.documentReducer.exportData.responseData?.exported_file
  );

  const getExportDataApiCallResponse = useSelector(
    (state) => state.documentReducer.exportDataApiCall
  );

  useEffect(() => {
    if (getExportDataResponse != null && true == getExportDataApiCallResponse) {
      if ("excel" == exportType) {
        Base64ToExcelDownload(getExportDataResponse, "InvoiceList.xlsx");
      } else {
        uploadedFileDownload(
          getExportDataResponse,
          "InvoiceList.pdf",
          `data:application/pdf;base64`
        );
      }
      dispatch(getExportDataApiCall(false));
      DealBookSearch.url = "";
      DealBookSearch.exportType = "";
      DealBookSearch.isExport = null;
    }
  });
  //Export end
  //download doc
  const downloadAllDocuments = useSelector(
    (state) => state?.invoiceListReducer?.downloadAllDocuments
  );

  useEffect(() => {
    if (downloadAllDocuments.length != 0 && downclick == true) {
      // Convert the base64 data to binary
      const binaryData = atob(downloadAllDocuments);
      const byteArray = new Uint8Array(binaryData.length);
      for (let i = 0; i < binaryData.length; i++) {
        byteArray[i] = binaryData.charCodeAt(i);
      }

      // Create a Blob from the binary data
      const blob = new Blob([byteArray], { type: "application/zip" });

      // Create a URL for the Blob
      const url = URL.createObjectURL(blob);

      // Create a link and trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.download = "invoice.zip";
      document.body.appendChild(link);
      link.click();

      // Clean up by revoking the URL
      URL.revokeObjectURL(url);
      setdownclick(false);
    }
  }, [downloadAllDocuments]);

  //CheckBox
  const allDocDownload = () => {
    let selectedBuyer = [];

    rows &&
      rows.map((rows, ViewDealBookTaoDataIndex) => {
        if (rows && rows.isSelected && true == rows.isSelected) {
          selectedBuyer.push(rows);
        }
      });

    if (selectedBuyer && selectedBuyer.length == 0) {
      toast.error("Please select at least one record");
      return;
    }
    let commadata = selectedBuyer.map((item) => item.invoiceNumber).join(",");
    let downloadAlldata = {
      commaseprateddata: commadata,
      userCode: atob(sessionStorage.getItem("argument6")).toString(),
    };
    setdownclick(true);
    dispatch(downloadAllDocument(downloadAlldata));
  };
  const handleSelectAll = (isChecked) => {
    const updatedRows = rows.map((row) => ({
      ...row,
      isSelected: isChecked, // Set all rows to the checked state
    }));

    setRows(updatedRows); // Update the rows state
    setIsAllSelected(isChecked);
    const selectedInvoiceIds = isChecked
      ? updatedRows.map((row) => row.invoiceNumber) // Collect all invoiceIds if "Select All" is checked
      : []; // Empty array if unchecking "Select All"

    setSelectedInvoices(selectedInvoiceIds); // Update selected invoices
  };

  const checkBoxSelect = (index) => {
    const updatedRows = rows.map((row, i) => ({
      ...row,
      isSelected: i === index ? !row.isSelected : row.isSelected, // Toggle selection for the clicked row
    }));

    setIsAllSelected(updatedRows.every((row) => row.isSelected)); // Check if all rows are selected

    const selectedInvoiceIds = updatedRows
      .filter((row) => row.isSelected)
      .map((row) => row.invoiceNumber);

    setSelectedInvoices(selectedInvoiceIds);
    setRows(updatedRows);
  };

  useEffect(() => {
    dispatch(
      getAllAuctionCenterAscAction({
        sortBy: "asc",
        sortColumn: "auctionCenterName",
      })
    );
  }, []);

  useEffect(() => {
    if (
      DealBookSearch.saleNo != "" &&
      DealBookSearch.saleNo != undefined &&
      DealBookSearch.saleNo != null
    ) {
      dispatch(
        getAllTaxInvoiceSaleAction({
          season: seasonYear.toString(),
          saleNo: DealBookSearch.saleNo,
          auctionCenterId: DealBookSearch.auctionCentre,
        })
      );
    }
  }, [DealBookSearch.saleNo]);

  //vimal_eptl
  useEffect(() => {
    const saleNo = DealBookSearch.saleNo;
    if (saleNo) {
      fetchInvoiceNumbers();
      featchLotNumber();
    }
  }, [DealBookSearch.saleNo]);

  useEffect(() => {
    setallLoatNo(loatNoList);
  }, [loatNoList]);

  const SearchViewDealBook = (e) => {
    e.preventDefault();
    setLoader(true);
    ViewDealBookList();
    setIsAllSelected(false);
    // setSelectedInvoices([])
    // setpageNo(1);


  };

  useEffect(() => {
    setpageNo(1)
  }, [DealBookSearch.saleNo])

  const handleViewMore = async () => {
    setIsDisabled(true);
    let updatedPageNo = pageNo;
    const updatedRows = rows.map((row) => ({ ...row, isSelected: false }));
    setRows(updatedRows);
    setIsAllSelected(false);

    await dispatch(
      get_searchinvoicelist({
        ...DealBookSearch,
        pageNo: updatedPageNo,
        noOfRecords: NO_OF_RECORDS,
        userId: parseInt(atob(sessionStorage.getItem("argument2"))),
      })
    );
    // setIsDisabled(false);
    updatedPageNo = pageNo + 1;
    setpageNo(updatedPageNo);

  };

  const ResetViewBook = (e) => {
    e.preventDefault();
    setallSaleNoList([]);
    setDealBookSearch({
      season: seasonYear.toString(),
      roleCode: roleCode,
      saleNo: "",
      teaType: "",
      auctionDate: "",
      status: "",
      lotNo: "",
      invoiceNumber: "",
      einvoiceEligibility: "",
      auctionCentre: "",
      userId: parseInt(atob(sessionStorage.getItem("argument2"))),
      bilingType:""
    });
    get_searchinvoicelist({
      ...DealBookSearch,
      pageNo: pageNo,
      noOfRecords: NO_OF_RECORDS,
      invoiceNos: selectedInvoices?.join(",")
    });
    setViewDealBookTaoData([]);
  };

  //vimal

  const handleViewDealSearch = async (e) => {
    const { name, value } = e.target;
    const userId = parseInt(atob(sessionStorage.getItem("argument2")));
    const seasonValue = name === "season" ? String(value) : value;
    setDealBookSearch((prevDealBookSearch) => ({
      ...prevDealBookSearch,
      [name]: value,
    }));
    setSeason(seasonValue);
    if (
      name == "auctionCentre" &&
      atob(sessionStorage.getItem("argument6")) == "TAOUSER"
    ) {
      let lotnojson = {
        auctionCenter:
          e.target.value == undefined || e.target.value == ""
            ? 0
            : e.target.value,
        userid: atob(sessionStorage.getItem("argument2")).toString(),
      };
      // dispatch(getlotnofortao(lotnojson));
    }
    if (
      atob(sessionStorage.getItem("argument6")) === "TAOUSER" &&
      name == "auctionCentre" &&
      value !== ""
    ) {
      try {
        const response = await axiosMain.get(
          `postauction/invoiceList/getInvoiceNoForTao/${userId}/${value}`
        );
        if (response.data) {
          setInvoiceNo(response.data.responseData);
        }
      } catch (error) {
        console.error("Failed to fetch invoice numbers:", error);
      }
    }
    fetchInvoiceNumbers();
  };

  const getAllAuctionCenterList = useSelector(
    (state) => state?.auctionCenter?.getAllAuctionCenterAsc?.responseData
  );

  const isActiveAuctionCenterData =
    getAllAuctionCenterList &&
    getAllAuctionCenterList?.filter((data) => 1 == data.isActive);

  const [file, setFile] = useState();
  const [imageUrl, setImageUrl] = useState(null);
  const handlePreview = (invoiceNo) => {
    let previewPdfparam = {
      invoiceNo: invoiceNo,
      role: atob(sessionStorage.getItem("argument6")).toString(),
    };
    dispatch(previewpdf(previewPdfparam));
    setShowmodal(true);
  };
  const handlesingledownload = (invoiceNo) => {
    let downloaddata = {
      commaseprateddata: invoiceNo,
      userCode: atob(sessionStorage.getItem("argument6")).toString(),
    };
    setdownclick(true);
    dispatch(downloadAllDocument(downloaddata));
  };
  const pdfPreviewdata = useSelector(
    (state) => state?.invoiceListReducer?.previewpdf?.responseData
  );
  useEffect(() => {
    if (
      pdfPreviewdata != null &&
      pdfPreviewdata != undefined &&
      pdfPreviewdata != ""
    ) {
      setFile(pdfPreviewdata);
      setShowmodal(true);
    }
  }, [pdfPreviewdata]);
  const [pdfUrl, setPdfUrl] = useState("");
  useEffect(() => {
    if (file) {
      try {
        const byteCharacters = atob(file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
        console.log("url", url);
        return () => {
          URL.revokeObjectURL(url);
        };
      } catch (error) {
        console.error("Error converting Base64 to Blob: ", error);
      }
    }
  }, [file]);

  useEffect(() => {
    if (
      DealBookSearch.auctionCentre != "" &&
      DealBookSearch.auctionCentre != undefined &&
      DealBookSearch.auctionCentre != null
    ) {
      let data = {
        auctionCenterId: DealBookSearch.auctionCentre,
        season: DealBookSearch.season,
      };
      dispatch(bindsalenobyseason(data));
      dispatch(
        getusersbyauctioncenter({
          auctionCenterId: parseInt(DealBookSearch.auctionCentre),
          roleCode: atob(sessionStorage.getItem("argument6")).toString(),
        })
      );
    }
  }, [DealBookSearch.auctionCentre, DealBookSearch.season]);

  useEffect(() => {
    setDealBookSearch({
      season: seasonYear.toString(),
      roleCode: roleCode,
      saleNo: "",
      teaType: "",
      auctionDate: "",
      // buyerName: "",
      status: "",
      lotNo: "",
      invoiceNumber: null,
      bilingType: "",
      einvoiceEligibility: "",
      auctionCentre: "",
      auctioneer: "",
      userId: "",
    });
    setRows([]);
    setallSaleNoList([])
    get_searchinvoicelist({
      ...DealBookSearch,
      pageNo: pageNo,
      noOfRecords: NO_OF_RECORDS,
    });
    setShowmodal(false);
    setViewDealBookTaoData([]);
    dispatch(getAllTeaTypes([]));
    dispatch(fetchMarkRequest([]));
    dispatch(fetchAuctionRequest([]));
    dispatch(getAllCategoriesAction([]));
  }, []);
  const [serialNumber, setserialNumber] = useState([]);
  const [selectedserialNumber, setselectedserialNumber] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      const url = "https://localhost:29739/signer";
      try {
        const data = {
          action: "0",
          serialNumber: null,
          data: null,
          publicKey: null,
          key: null,
        };
        console.log(qs.stringify(data));
        const response = await axios.post(url, qs.stringify(data), {});
        setserialNumber(response?.data?.signerResponse?.certificates);
        console.log("Response:", serialNumber);
      } catch (error) {
        console.error("Error:", error.message);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    setRows([]);
    setIsDisabled(true);

  }, [
    DealBookSearch.season,
    DealBookSearch.saleNo,
    DealBookSearch.auctionDate,
    DealBookSearch.einvoiceEligibility,
    DealBookSearch.lotNo,
    DealBookSearch.invoiceNumber,
    DealBookSearch.bilingType,
    DealBookSearch.teaType,
    DealBookSearch.auctioneer,
  ]);
  const handleDropdownChange = (event) => {
    const selectedSerialNumber = event.target.value;
    setselectedserialNumber(selectedSerialNumber);
  };

  const [isModalOpen, setModalOpen] = useState(false);
  const handlePostRequest = async () => {
    if (selectedInvoices?.length > 0 && selectedserialNumber !== null) {
      const url = "https://localhost:29739/teaboard/signer";
      const data = {
        action: "1",
        serialNumber: selectedserialNumber,
        data: null,
        publicKey: null,
        key: null,
      };
      try {
        const response = await axios.post(url, qs.stringify(data), {});
        const validTo = response.data.signerResponse.certificateDetail.validTo;
        const validDate = moment(validTo).format("YYYY-MM-DD HH:mm:ss");
        const currentDates = moment(currentDate).format("YYYY-MM-DD HH:mm:ss");
        console.log("Valid Date:", validDate);
        console.log("Current Date:", currentDates);
        const validD = new Date(validDate);
        const currentD = new Date(currentDates);
        const current_date = new Date();
        const isBetweenDates =
          currentD <= current_date && current_date <= validD;
        if (isBetweenDates) {
          setloading(true);
          const response1 = await axiosMain.post(
            "/postauction/sellertaxinvoice/base64DigitalSigns",
            {
              base64: "",
              filename: "",
              invoiceNo: "",
              invoicenolist: selectedInvoices,
              listOfBUyerInvoiceId: selectedInvoices,
              userId: userId,
            }
          );
          if (response1.data.statusCode === 200) {
            const base64Data = response1.data.responseData;
            setBase64Data(base64Data);
            const certResponse = await axios.post(url, qs.stringify(data), {});
            setviewcertificateDetail(
              certResponse?.data?.signerResponse?.certificateDetail
            );
            const datas = certResponse.data.signerResponse?.certificateDetail;
            const keyValuePairs = datas.clientName.split(",");
            const cnField = keyValuePairs.find((pair) => pair.includes("CN="));
            const name = cnField.split("=")[1].trim();
            let flag = false;
            datas.clientName = name;
            for (const name of base64Data) {
              const signData = {
                action: "1",
                serialnumber: data.serialNumber,
                src: name?.base64,
                reason: "-",
                field: "1-363,718,533,788",
                place: "-",
                certificateName: datas.clientName,
              };
              console.log("Location", signData);
              const signResponse = await axios.post(
                "https://localhost:29739/teaboard/allDocSignerallDocSigner",
                signData
              );
              setBase64savedigitalsign(signResponse.data);
              if (signResponse.data !== null && signResponse.data !== "") {
                const data1 = [
                  {
                    base64: signResponse.data.signerResponse.pdfsigndata,
                    filename: name.filename,
                    invoiceNo: name.invoiceNo,
                    invoicenolist: selectedInvoices,
                  },
                ];
                const saveResponse = await axiosMain.post(
                  "/postauction/sellertaxinvoice/saveDigitalSign",
                  data1
                );
                if (saveResponse.data.statusCode === 200) {
                  console.log("check_886", saveResponse.data);
                  //CustomToast.success("Digital signature saved successfully.");
                  flag = true;
                } else {
                  CustomToast.error(saveResponse.data.message);
                }
              }
            }
            if (flag) {
              CustomToast.success("Invoice (" + selectedInvoices.length + ") digitally signed successfully.");
              // setSelectedInvoices([]);
            }
          } else {
            setBase64Data([]);
            CustomToast.error(
              response1.data.message || "Failed to retrieve base64 data."
            );
          }
        } else {
          CustomToast.error("Digital Certificate is expired");
        }
      } catch (error) {
        console.error("Error making POST request:", error);
        CustomToast.error("An error occurred while processing your request.");
      } finally {
        setRows([])
        dispatch(
        get_searchinvoicelist({
          ...DealBookSearch,
          pageNo: 1,
          noOfRecords: NO_OF_RECORDS,
          userId: parseInt(atob(sessionStorage.getItem("argument2"))),
          invoicenos: selectedInvoices
          })
        );        
        setloading(false);
      }
    } else {
      CustomToast.error("Please select rows and select certificate.");
    }
  };

  let getAllTaxInvoiceResponseAllData = useSelector(
    (state) => state?.SellerTaxgen?.getAllSellerTaxGen
  );
  let getAllTaxInvoiceResponse = useSelector(
    (state) => state?.SellerTaxgen?.getAllSellerTaxGen?.responseData
  );

  const handleUploadClick = () => {
    let selectedBuyer = rows.filter(
      (viewTaxInvoiceData) => viewTaxInvoiceData.isSelected
    );
    if (selectedBuyer.length === 0) {
      toast.error("Please select at least one data to upload.");
      return;
    }
    setModalOpen(true);
  };

  const [exportTypes, setexportTypes] = useState("");
  const [catshowmodal, setcatshowmodal] = useState(false);
  const [confirmationModalVisible, setConfirmationModalVisible] =
    useState(false);

  const handleImportExcelClick = (exportTypes) => {
    setexportType("");
    let selectedBuyer = [];
    rows &&
      rows.map((row) => {
        if (row && row.isSelected) {
          let tempData = {
            invoiceNo: row.invoiceNumber,
            invoiceDate: row.invoiceDate,
            buyerGSTIN: row.buyerGSTIN,
            invoiceValue: row.totalInvoiceAmount,
            transferId: row.transferId,
            invoiceId: row.invoiceid,
            ackDate: "",
            ackNo: "",
            irn: "",
            ewb: "Success",
            userId: userId,
          };
          selectedBuyer.push(tempData);
        }
      });

    if (selectedBuyer.length === 0) {
      toast.error("Please select at least one data to generate GST IRN.");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(selectedBuyer);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Selected Buyers");
    // XLSX.writeFile(wb, "SelectedBuyers.xlsx");
    setexportTypes(exportTypes);
    let payload = {
      url: "postauction/gst/exportIrns",
      data: selectedBuyer,
    };
    dispatch(getExportDataSeller(payload));
    setcatshowmodal(false);
    setIsAllSelected(false);
    setConfirmationModalVisible(false);
    dispatch(getAllTaxInvoiceActionSuccess([]));
    dispatch(disableGSTExcel());
  };

  const getExportDataSellerResponse = useSelector(
    (state) => state.BuyerTaxInvoice.exportDataSeller.responseData
  );

  

  const getExportDataSellerApiCallResponse = useSelector(
    (state) => state.BuyerTaxInvoice.exportDataSellerApiCall
  );
  useEffect(() => {
    if (
      getExportDataSellerResponse != null &&
      getExportDataSellerApiCallResponse === true
    ) {
      dispatch(getExportDataSellerApiCall(false));
      getExportDataSellerResponse.map((base64String, index) => {
        const filename = `SellerTaxInvoiceDetails_${index + 1}.xlsx`;
        Base64ToExcelDownload(base64String, filename);
      });
    }
  }, [getExportDataSellerResponse, getExportDataSellerApiCallResponse]);

  const handleCloseModal = () => {
    const inputElement = document.getElementById("individualTaxInvoice");
    if (inputElement) {
      inputElement.value = "";
    }
    setModalOpen(false);
  };

  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [uploadDocumentError, setUploadDocumentError] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleFileUpload = (files) => {
    const newFiles = files?.map((file) => ({
      base64: file.documentContent,
      filename: file.documentName,
      invoiceno: file.invoiceNo,
      userId: atob(sessionStorage.getItem("argument2")),
    }));
    setUploadedDocuments(newFiles);
  };

  const handleUploadDocument = () => {
    if (uploadedFiles.length === 0) {
      setUploadDocumentError("Please select a file.");
    } else {
      let selectedBuyer = [];
      rows &&
        rows.map((rows, rowsIndex) => {
          if (rows && rows.isSelected && true == rows.isSelected) {
            selectedBuyer.push(rows.invoiceNo);
          }
        });

      if (selectedBuyer && selectedBuyer.length > 1) {
        toast.error("Must be select only one record");
        return;
      }

      const apiPayload = uploadedFiles.map((file) => ({
        base64: file.documentContent,
        filename: file.documentName,
        invoicenos: selectedInvoices,
        userId: parseInt(atob(sessionStorage.getItem("argument2"))),
      }));
      let urls = "postauction/sellertaxinvoice/gstresponse";
      dispatch(
        getGstExcelByIdAction({ urls, apiPayload: apiPayload && apiPayload[0] })
      );
      dispatch(disableIrnUploadDocumentButton());
      setUploadDocumentError(null);
      setModalOpen(false);
      setSelectedInvoices([])
      setUploadedFiles("");
      removeAllFiles("");
      setcatshowmodal(false);
      setIsAllSelected(false);
      setConfirmationModalVisible(false);
      dispatch(getAllTaxInvoiceActionSuccess([]));
      const inputElement = document.getElementById("individualTaxInvoice");
      if (inputElement) {
        inputElement.value = "";
      }
    }
  };
  const removeAllFiles = () => {
    setUploadedFiles([]);
    const inputElement = document.getElementById("sellerTaxInvoice");
    if (inputElement) {
      inputElement.value = "";
    }
  };

  return (
    <>
      <div>
        <div>
          <form onSubmit={SearchViewDealBook}>
            <div className="row">
              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Auction Center </label>
                  <label className="errorLabel"> * </label>
                  <select
                    name="auctionCentre"
                    value={DealBookSearch.auctionCentre}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="">Select Auction Center</option>
                    {isActiveAuctionCenterData?.map(
                      (allAuctionCenterList, index) => (
                        <option value={allAuctionCenterList.auctionCenterId}>
                          {allAuctionCenterList.auctionCenterName}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>

              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Season</label>
                  <label className="errorLabel"> * </label>
                  <select
                    name="season"
                    value={DealBookSearch.season}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                    disabled={
                      null == DealBookSearch.auctionCentre ||
                        "" == DealBookSearch.auctionCentre
                        ? true
                        : false
                    }
                  >
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Sale No</label>
                  <label className="errorLabel"> * </label>
                  <select
                    name="saleNo"
                    onChange={handleViewDealSearch}
                    value={DealBookSearch.saleNo}
                    className="form-control select-form"
                  >
                    <option value="">Select Sale No</option>
                    {allSaleNoList?.map((allSaleNoList, index) => (
                      <option value={allSaleNoList.saleNo}>
                        {allSaleNoList.saleNo}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Auction Date </label>
                  <select
                    name="auctionDate"
                    value={DealBookSearch.auctionDate}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="">Select Auction Date </option>
                    {allAuctionDate?.map((allAuctionDate, index) => (
                      <option value={allAuctionDate.saleDate}>
                        {allAuctionDate.saleDate}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label> E-Invoice Eligibility </label>
                  <select
                    name="einvoiceEligibility"
                    value={DealBookSearch.einvoiceEligibility}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="">Select E-Invoice Eligibility</option>
                    <option value="1">Yes </option>
                    <option value="0">No </option>
                  </select>
                </div>
              </div>
              {/* <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Lot No</label>
                  <select
                    name="lotNo"
                    value={DealBookSearch.lotNo}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="">Select Lot No</option>
                    {allLoatNo.map((allLoatNo, index) => (
                      <option value={allLoatNo} key={index}>
                        {allLoatNo}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}
              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Invoice Number</label>
                  <select
                    name="invoiceNumber"
                    value={DealBookSearch.invoiceNumber}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="">Select Invoice No</option>
                    {invoiceNo?.map((invoice, index) => (
                      <option value={invoice} key={index}>
                        {invoice}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Invoice (Billing) Type</label>
                  <select
                    name="bilingType"
                    value={DealBookSearch.bilingType}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="">Select Billing Type</option>
                    <option value="1">Seller to Auctioneer(Goods)</option>
                    <option value="2">Seller to Buyer(Goods)</option>
                    <option value="3">Auctioneer to Buyer (Goods)</option>
                    <option value="4">Auctioneer to Buyer (Service)</option>
                    <option value="5">Auctioneer to Seller (Service)</option>
                    <option value="6">Tea Board to Seller (Service)</option>
                    <option value="7">Tea Board to Auctioneer (Service)</option>
                    <option value="8">Tea Board to Buyer (Service)</option>
                    <option value="9">Tea Board to Warehouse (Service)</option>
                    {/* <option value="10">Seller Tax Invoice</option> */}
                  </select>
                </div>
              </div>
              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Status</label>
                  <select
                    name="status"
                    value={DealBookSearch.status}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="">Select Status</option>
                    <option value="3">IRN Pending</option>
                    <option value="1">Digital Sign Pending</option>
                    <option value="5">Ready for Download </option>
                  </select>
                </div>
              </div>
              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Tea Type</label>
                  <select
                    name="teaType"
                    value={DealBookSearch.teaType}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="">Select Tea Type</option>
                    {allTeaType?.map((allTeaTypeList, index) => (
                      <option value={allTeaTypeList.teaTypeId}>
                        {allTeaTypeList.teaTypeName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Auctioneer Name </label>
                  <select
                    name="auctioneer"
                    value={DealBookSearch.auctioneer}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="">Select Auctioneer Name</option>
                    {allAuctioneerList?.map((allAuctioneerList, index) => (
                      <option value={allAuctioneerList.userId} key={index}>
                        {allAuctioneerList.userName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {modalRight?.some((ele) => ele === "12") && (
                <div className="col-12">
                  <div className="BtnGroup">
                    <button type="submit" className="SubmitBtn">
                      Search
                    </button>
                    <button
                      type="button"
                      className="SubmitBtn"
                      onClick={ResetViewBook}
                    >
                      Clear
                    </button>
                    {rows?.length > 0 &&
                      (DealBookSearch.bilingType == 5 ||
                        DealBookSearch.bilingType == 6 ||
                        DealBookSearch.bilingType == 7 ||
                        DealBookSearch.bilingType == 8 ||
                        DealBookSearch.bilingType == 9) && (
                        <>
                          <div className="col-xl-2">
                            <div className=" ">
                              <label>Certificates </label>
                              <select
                                name="auctionDate"
                                value={selectedserialNumber}
                                className="form-control select-form"
                                onChange={handleDropdownChange}
                              >
                                <option value="">Select Certificate </option>
                                {serialNumber?.map((item) => (
                                  <option
                                    key={item.serialNumber}
                                    value={item.serialNumber}
                                  >
                                    {item.clientName}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="SubmitBtn"
                            onClick={() => handlePostRequest()}
                            disabled={Loading == true}
                          >
                            Digital sign
                            {Loading == true ? (
                              <>
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </button>
                          <button
                            class="SubmitBtn"
                            onClick={() => handleImportExcelClick()}
                            disabled={isGstExcelDisabled}
                          >
                            GST Excel
                            {isGstExcelDisabled == true ? (
                              <>
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </button>
                          <button
                            className="SubmitBtn"
                            onClick={() => handleUploadClick()}
                            disabled={isIRNUploadDocumentDisabled}
                          >
                            IRN Upload Document
                            {isIRNUploadDocumentDisabled == true ? (
                              <>
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </button>
                        </>
                      )}

                    {rows?.length > 0 ? (
                      <>
                        {modalRight?.some((ele) => ele === "48") && (
                          <button
                            type="button"
                            class="SubmitBtn"
                            title="Export Excel"
                            onClick={() => handleExport("excel")}
                          >
                            <i class="fa fa-file-excel"></i>
                          </button>
                        )}
                        {modalRight?.some((ele) => ele === "47") && (
                          <button
                            class="SubmitBtn"
                            title="Export PDF"
                            onClick={() => handleExport("pdf")}
                          >
                            <i class="fa fa-file-pdf"></i>
                          </button>
                        )}
                        {modalRight?.some((ele) => ele === "63") && (
                          <button
                            type="button"
                            className="Excel"
                            title="Download All Invoice"
                            onClick={() => allDocDownload()}
                          >
                            <i className="fa fa-file-archive"></i>
                          </button>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
        {modalRight?.some((ele) => ele === "12") && (
          <div className="row mt-4">
            <div className="col-12">
              <div className="row my-4">
                <div className="col-md-auto">
                  <strong>
                    <span className="totals">Total Count :</span>{" "}
                    {rows === [] ||
                      rows === undefined ||
                      rows === null
                      ? 0
                      : rows?.length}
                  </strong>
                </div>
              </div>
              <div className="TableBox11">
                <table className="table11">
                  <thead>
                    <tr>
                      {rows?.length > 0 ? (
                        <th>
                          <center>
                            <input
                              type="checkbox"
                              checked={isAllSelected}
                              onChange={(e) =>
                                handleSelectAll(e.target.checked)
                              }
                            />
                          </center>
                        </th>
                      ) : (
                        ""
                      )}
                      <th>Sr No.</th>
                      <th>Auction Centre</th>
                      <th>Season</th>
                      <th>Sale No</th>
                      <th>Auction Date</th>
                      <th>E-Invoice Eligibility</th>
                      <th>IRN Status</th>
                      {/* <th>Lot No</th> */}
                      <th>Tea Type</th>
                      <th>Invoice Number</th>
                      <th>Invoice Date</th>
                      <th>Auctioneer</th>
                      <th>Invoice (Billing) Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loader ? (
                      <>
                        <div className="">
                          <ThreeDots
                            visible={true}
                            height="80"
                            width="80"
                            color="#4fa94d"
                            radius="9"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        {rows?.length > 0 ? (
                          <>
                            {rows?.map((data, index) => (
                              <tr key={index}>
                                <td className="text-center">
                                  <input
                                    type="checkbox"
                                    checked={data.isSelected || false}
                                    onChange={() => checkBoxSelect(index)}
                                  />
                                </td>
                                <td>{index + 1}</td>
                                <td>{data.auctionCentre}</td>
                                <td>{data.season}</td>
                                <td>{data.saleNo}</td>
                                <td>{data.auctionDate}</td>
                                <td>{data.einvoiceEligibility}</td>
                                <td>{data.irnStatus}</td>
                                {/* <td>{data.lotNo}</td> */}
                                <td>{data.teaType}</td>
                                <td>{data.invoiceNumber}</td>
                                <td>{data.invoiceDate}</td>
                                <td>{data.auctioneerName}</td>
                                <td>{data.bilingType}</td>
                                <td className="Action">
                                  {data.cstatus == 5 ? (
                                    <>
                                      {modalRight?.some(
                                        (ele) => ele === "61"
                                      ) && (
                                          <i
                                            className="fa fa-eye"
                                            title="Preview"
                                            onClick={() =>
                                              handlePreview(data.invoiceNumber)
                                            }
                                          ></i>
                                        )}
                                      {modalRight?.some(
                                        (ele) => ele === "62"
                                      ) && (
                                          <i
                                            className="fa fa-download"
                                            title="Download"
                                            onClick={() =>
                                              handlesingledownload(
                                                data.invoiceNumber
                                              )
                                            }
                                          ></i>
                                        )}
                                    </>
                                  ) : (
                                    <>
                                      {modalRight?.some(
                                        (ele) => ele != "61"
                                      ) && <i>-</i>}
                                      {modalRight?.some(
                                        (ele) => ele != "62"
                                      ) && <i>-</i>}
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td colSpan={30}>
                              <div className="NoData">No record found</div>
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
              {/* {rows?.length > 19 ? ( */}
                <>
                  <button
                    class="SubmitBtn"
                    onClick={handleViewMore}
                    // disabled={searchResultss && searchResultss.length < 19}
                    disabled={isDisabled || (searchResultss && searchResultss.length < 19)}
                  >
                    View More
                  </button>
                </>
                <div style={{fontWeight: "600"}}>
                <span style={{background: "yellow"}}>Note: </span> IRN is currently being processed. Please wait for 2 minutes before clicking the Search button. The Download and View Item options will become available in the Action column once processing is complete.
                </div>
              {/* ) : (
                ""
              )} */}
            </div>
          </div>
        )}
      </div>
      {showmodal && (
        <Modal show={showmodal} onHide={handleCloseHistory} size="xl" centered>
          <Modal.Header>
            <Modal.Title>Preview</Modal.Title>
            <i
              className="fa fa-times CloseModal"
              onClick={handleCloseHistory}
            ></i>
          </Modal.Header>
          <Modal.Body className="Preview">
            <div className="PdfBox">
              {/* Use iframe to embed PDF content */}
              <iframe
                src={pdfUrl}
                width="100%"
                height="600px"
                onError={(e) =>
                  console.error("Failed to load PDF document:", e)
                }
              />
            </div>
          </Modal.Body>
        </Modal>
      )}

      {isModalOpen && (
        <div>
          <Modal
            show={isModalOpen}
            onHide={handleCloseModal}
            size="xl"
            centered
          >
            <Modal.Header>
              <Modal.Title>Upload Invoice Details</Modal.Title>
              <i
                className="fa fa-times CloseModal"
                onClick={handleCloseModal}
              ></i>
            </Modal.Header>
            <Modal.Body>
              <div className="col-md-12">
                <UploadZip
                  onFileSelect={handleFileUpload}
                  uploadedFiles={uploadedFiles}
                  setUploadedFiles={setUploadedFiles}
                  uploadDocumentError={uploadDocumentError}
                  inputId="sellerTaxInvoice"
                />
              </div>
              {uploadDocumentError && (
                <div className="error-message">{uploadDocumentError}</div>
              )}
              <div>
                <button className="SubmitBtn" onClick={handleUploadDocument}>
                  Upload
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
}

export default InvoiceList;
